<template>
  <v-card raised :height="height">
    <v-system-bar :color="color" dark>
      {{ title }}
      <v-spacer></v-spacer>
      <!-- <div class="otherButtons"> -->
      <generic-button
        v-for="(button, idx) in otherButtons"
        :key="idx"
        :icon="button.icon"
        :event="button.event"
        :tooltip="button.tooltip"
        @click="clickOtherButton"
      >
      </generic-button>
      <!-- </div> -->
      <v-spacer></v-spacer>

      <show-parameters-button
        v-if="parambuttonvisible == true"
        @click="$emit('show-parameters')"
      ></show-parameters-button>
      <show-help-button
        v-if="helpbuttonvisible == true"
        @click="$emit('show-help')"
      ></show-help-button>
      <minimize-button
        v-if="minimizebuttonvisible == true"
        @click="$emit('hide')"
      ></minimize-button>
    </v-system-bar>
    <slot></slot>
  </v-card>
</template>
<script>
import MinimizeButton from '@/components/generic/buttons/MinimizeButton.vue';
import ShowParametersButton from '@/components/generic/buttons/ShowParametersButton.vue';
import ShowHelpButton from '@/components/generic/buttons/ShowHelpButton.vue';
import GenericButton from '@/components/generic/buttons/GenericButton.vue';

export default {
  components: { MinimizeButton, ShowParametersButton, ShowHelpButton, GenericButton },
  props: {
    color: { type: String, default: 'white' },
    title: { type: String, default: '' },
    parambuttonvisible: { type: Boolean, default: true },
    minimizebuttonvisible: { type: Boolean, default: true },
    helpbuttonvisible: { type: Boolean, default: false },
    otherButtons: { type: Array, default: () => [] },
    height: { type: Number, default: 400 },
  },
  data() {
    return {};
  },
  methods: {
    clickOtherButton(event) {
      this.$emit(event);
    },
  },
};
</script>

<style scoped>
.otherButtons {
  margin-right: 20px;
}
</style>
